import {useStoredSettingsValue} from '../../../../../../../../contexts/StoredSettingsValue/StoredSettingsValueContext'

import {
  DOCKERFILE_PATH_PROPERTY_NAME,
  DOCKERFILE_SOURCE_PROPERTY_NAME,
  DOCKER_IMAGE_PROPERTY_NAME,
} from './JobStepRunInDocker.consts'

export function useStoredDockerData(type: string, stepIndex: number) {
  const {getValueFromStoredSettings} = useStoredSettingsValue()

  const storedDockerImageKey = `${type}_${DOCKER_IMAGE_PROPERTY_NAME}_${stepIndex}`
  const storedDockerfileSourceKey = `${type}_${DOCKERFILE_SOURCE_PROPERTY_NAME}_${stepIndex}`
  const storedDockerfilePathKey = `${type}_${DOCKERFILE_PATH_PROPERTY_NAME}_${stepIndex}`

  const storedDockerImageValue = getValueFromStoredSettings(storedDockerImageKey) ?? ''
  const storedDockerfileSourceValue = getValueFromStoredSettings(storedDockerfileSourceKey) ?? ''
  const storedDockerfilePathValue = getValueFromStoredSettings(storedDockerfilePathKey) ?? ''

  return {
    storedDockerImageKey,
    storedDockerfileSourceKey,
    storedDockerfilePathKey,
    storedDockerImageValue: storedDockerImageValue as string,
    storedDockerfileSourceValue: storedDockerfileSourceValue as string,
    storedDockerfilePathValue: storedDockerfilePathValue as string,
  }
}
